import { BodyText, TitleText } from 'styling/Typography'
import { AccommodationStep, AccomodationBlockReveiw, AddAccommodationModalContainer, AddAccommodationModalContnet, AddAccommodationModalWrapper, AddAccommodationSteps, BlockContainer, CampContainer, CampOverviewContainer, ColoredSquare, IconContainer, ModalCloseBtn, RemoveItemBtn } from '../Accommodation.style'
import { Box, Button, colors, Flex, SectionButton } from 'styling/GlobalStyles'
import React, { useState } from 'react'
import { HouseIcon } from '../icons/HouseIcon'
import { Input } from 'components/Input/Input'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { OrangeBlockIcon } from '../icons/OrangeBlockIcon'
import { OrangeRoomIcon } from '../icons/OrangeRoomIcon'
import { OrangeBedIcon } from '../icons/OrangeBedIcon'
import { OrangeHouseIcon } from '../icons/OrangeHouse'
import { SmallOrangeBedIcon } from '../icons/SmalOrangeBedIcon'
import { IAccommodationModalCamp } from 'types/accommodation.interface'
import { PartyIcon } from '../icons/PartyIcon'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { createCamp } from 'features/accommodation/accommodationSlice'
import { tierOptions } from './CheckIn'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { toast } from 'react-toastify'

const statusOptions = [{ label: 'Active', value: 1 }, { label: 'Inactive', value: 2 }]
const genderOptions = [{ label: 'Male', value: 1 }, { label: 'Female', value: 2 }, { label: 'Both', value: 3 }]

const FirstStep = ({ setCamp, camp, tried }) => {

    const initiateCamp = () => {
        setCamp({
            name: '',
            address: '',
            coordinates: { latitude: null, longitude: null },
            status: null,
            blocks: []
        })
    }


    const NoCampAdded = () => {
        return <Flex column gap='0.5rem' width='100%' height='100%' center justcenter >
            <IconContainer><HouseIcon /> </IconContainer>
            <TitleText>No camp created</TitleText>
            <Button orange onClick={initiateCamp} >Create Camp</Button>
        </Flex>
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Create Camp</TitleText>
            <TitleText grey >Follow the steps to set up your camp structure</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1 }}  >
            {!camp ? <NoCampAdded /> :
                <Flex column gap='1rem' >
                    <Box>
                        <Flex column gap='1rem' >
                            <Input value={camp.name} onChange={e => setCamp({ ...camp, name: e.target.value })} placeholder='Camp 1...' labelText='Name' nomarg invalid={tried && !camp.name} />
                            <Input value={camp.address} onChange={e => setCamp({ ...camp, address: e.target.value })} labelText='Address' placeholder='Main Street 123...' nomarg invalid={tried && !camp.address} />
                            <HonestSelectInput defaultValue={camp.status?.value} onChange={(v: ISelectValue) => setCamp({ ...camp, status: v })} options={statusOptions} labelText='Status' invalid={tried && !camp.status} />
                        </Flex>
                    </Box>
                </Flex>
            }
        </Box>
    </>
}
const SecondStep = ({ camp, setCamp, tried }) => {
    const initiateBlocks = () => {
        setCamp(prev => {
            return {
                ...prev, blocks: [...prev.blocks, {
                    id: new Date().getTime(),
                    name: 'Blok ' + (prev.blocks.length + 1),
                    genderPolicy: null,
                    tierPolicy: null,
                    status: null,
                    rooms: []
                }]
            }
        })
    }

    const removeBlock = (blockId: number) => {
        setCamp(prev => ({ ...prev, blocks: prev.blocks.filter(b => b.id !== blockId) }))
    }

    const NoBlocksAdded = () => {
        return <Flex column gap='0.5rem' width='100%' height='100%' center justcenter >
            <IconContainer><HouseIcon /> </IconContainer>
            <TitleText>No blocks added</TitleText>
            <Button orange onClick={initiateBlocks} >Create Block</Button>
        </Flex>
    }

    const handleSelect = (value: ISelectValue, name: string, blockId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === blockId ? { ...b, [name]: value } : b)
            }
        })
    }

    const handleInput = (value: string, name: string, blockId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === blockId ? { ...b, [name]: value } : b)
            }
        })
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Blocks to Camp</TitleText>
            <TitleText grey >Blocks are major subdivisions within your camp</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            {!camp?.blocks?.length ? <NoBlocksAdded /> : <Flex column gap='1rem' >
                {
                    camp.blocks.map(b => <Box key={b.id} >
                        <Flex column gap='1rem' >
                            <Flex between center gap='0.5rem' >
                                <BodyText weight='bold' >{b.name || 'Unnamed Block'}</BodyText>
                                <RemoveItemBtn type='button' onClick={() => removeBlock(b.id)} aria-label='Remove block'>
                                    <CloseIcon />
                                </RemoveItemBtn>
                            </Flex>
                            <Input value={b.name} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInput(e.target.value, 'name', b.id)} placeholder='Block 1...' labelText='Name' nomarg invalid={tried && !b.name} />
                            <HonestSelectInput defaultValue={b.status?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={statusOptions} labelText='Status' nomarg name='status' invalid={tried && !b.status} />
                            <HonestSelectInput defaultValue={b.genderPolicy?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={genderOptions} labelText='Gender Policy' nomarg name='genderPolicy' invalid={tried && !b.genderPolicy} />
                            <HonestSelectInput defaultValue={b.tierPolicy?.value} onChange={(v: ISelectValue, n: string) => handleSelect(v, n, b.id)} options={tierOptions} labelText='Tier Policy' nomarg name='tierPolicy' invalid={tried && !b.tierPolicy} />
                        </Flex>
                    </Box>)
                }
                <Button orange width='100%' mt='32' onClick={initiateBlocks} >Add Another Block</Button>
            </Flex>}
        </Box>
    </>
}
const ThirdStep = ({ camp, setCamp, tried }) => {
    const [selectedBlock, setSelectedBlock] = useState(camp?.blocks?.[0]?.id ?? null)

    const initiateRooms = () => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => {
                    if (b.id === selectedBlock) {
                        return {
                            ...b, rooms: [...b.rooms, {
                                id: new Date().getTime(),
                                name: 'Room ' + (b.rooms.length + 1),
                                capacity: null,
                                status: null,
                                beds: []
                            }]
                        }
                    }
                    return b
                })
            }
        })
    }

    const removeRoom = (e: React.MouseEvent, blockId: number, roomId: number) => {
        e.stopPropagation()
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b => b.id === blockId ? { ...b, rooms: b.rooms.filter(r => r.id !== roomId) } : b)
        }))
    }


    const handleSelect = (value: ISelectValue, roomId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === selectedBlock ? { ...b, rooms: b.rooms.map(r => r.id === roomId ? { ...r, status: value } : r) } : b)
            }
        })
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>, roomId: number) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => b.id === selectedBlock ? {
                    ...b, rooms: b.rooms.map(r => {
                        if (r.id !== roomId) return r
                        if (e.target.name === 'capacity') {
                            const cap = e.target.valueAsNumber
                            const beds = (r.beds || []).slice(0, isNaN(cap) ? 0 : cap)
                            return { ...r, capacity: isNaN(cap) ? null : cap, beds }
                        }
                        return { ...r, [e.target.name]: e.target.value }
                    })
                } : b)
            }
        })
    }

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Rooms to Blocks</TitleText>
            <TitleText grey >Define rooms within each block and set their policies</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex column gap='1rem' >
                {
                    camp?.blocks?.map(b => <CampContainer key={b.id} onClick={() => setSelectedBlock(b.id)} active={selectedBlock == b.id} >
                        <CampOverviewContainer>
                            <TitleText>{b.name}</TitleText>
                            {tried && !b.rooms?.length && <BodyText style={{ color: '#FF4F46' }} >At least one room required</BodyText>}
                        </CampOverviewContainer>
                        <BlockContainer style={{ gap: '0.5rem', display: 'flex' }} >
                            <Flex column gap='0.5rem' width='100%'>

                                {b.rooms.map(r => <Box key={r.id} width='100%' style={{ flex: 1 }}>
                                    <Flex column gap='1rem' >
                                        <Flex between center gap='0.5rem' >
                                            <BodyText weight='bold' >{r.name || 'Unnamed Room'}</BodyText>
                                            <RemoveItemBtn type='button' onClick={(e) => removeRoom(e, b.id, r.id)} aria-label='Remove room'>
                                                <CloseIcon color='#FF4F46' />
                                            </RemoveItemBtn>
                                        </Flex>
                                        <Input placeholder='Block 1...' value={r.name} onChange={e => handleInput(e, r.id)} name='name' labelText='Name' nomarg invalid={tried && !r.name} />
                                        <Flex between gap='1rem' >
                                            <Input value={r.capacity ?? ''} onChange={e => handleInput(e, r.id)} placeholder='15' labelText='Capacity' name='capacity' type='number' nomarg invalid={tried && (!r.capacity || r.capacity <= 0)} />
                                            <HonestSelectInput name='status' defaultValue={r.status?.value} onChange={(v: ISelectValue) => handleSelect(v, r.id)} options={statusOptions} labelText='Status' nomarg invalid={tried && !r.status} />
                                        </Flex>
                                    </Flex>
                                </Box>)}
                                <Button orange onClick={initiateRooms} > Add Room </Button>
                            </Flex>
                        </BlockContainer>
                    </CampContainer>)
                }
            </Flex>
        </Box>
    </>

}
const FourthStep = ({ camp, setCamp, tried }) => {

    const [selectedBlock, setSelectedBlock] = useState(camp?.blocks?.[0]?.id ?? null)

    const initiateBed = (roomId) => {
        setCamp(prev => {
            return {
                ...prev, blocks: prev.blocks.map(b => {
                    if (b.id === selectedBlock) {
                        return {
                            ...b, rooms: b.rooms.map(r => {
                                if (r.id === roomId) {
                                    if (r.capacity != null && r.beds.length >= r.capacity) {
                                        return r
                                    }
                                    return { ...r, beds: [...r.beds, { id: new Date().getTime(), name: 'Bed ' + (r.beds.length + 1), state: null }] }
                                }
                                return r
                            })
                        }
                    }
                    return b
                })
            }
        })
    }

    const removeBed = (roomId: number, bedId: number) => {
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b =>
                b.id === selectedBlock
                    ? {
                        ...b,
                        rooms: b.rooms.map(room =>
                            room.id === roomId
                                ? { ...room, beds: room.beds.filter(bed => bed.id !== bedId) }
                                : room
                        )
                    }
                    : b
            )
        }))
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>, roomId: number, bedId: number) => {
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b =>
                b.id === selectedBlock
                    ? {
                        ...b,
                        rooms: b.rooms.map(room =>
                            room.id === roomId
                                ? {
                                    ...room,
                                    beds: room.beds.map(bed =>
                                        bed.id === bedId ? { ...bed, name: e.target.value } : bed
                                    )
                                }
                                : room
                        )
                    }
                    : b
            )
        }))
    }

    const handleSelect = (v: ISelectValue, roomId: number, bedId: number) => {
        setCamp(prev => ({
            ...prev,
            blocks: prev.blocks.map(b =>
                b.id === selectedBlock
                    ? {
                        ...b,
                        rooms: b.rooms.map(room =>
                            room.id === roomId
                                ? {
                                    ...room,
                                    beds: room.beds.map(bed =>
                                        bed.id === bedId ? { ...bed, state: v } : bed
                                    )
                                }
                                : room
                        )
                    }
                    : b
            )
        }))
    }

    const activeBlock = camp?.blocks?.find(b => b.id === selectedBlock)

    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Add Beds to Rooms</TitleText>
            <TitleText grey >Specify how many beds are in each room</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex column gap='1rem' >
                <Flex width='100%' wrap gap='1rem' >{camp?.blocks?.map(b => <SectionButton key={b.id} active={selectedBlock === b.id} onClick={() => setSelectedBlock(b.id)} >{b.name}</SectionButton>)}</Flex>
                {selectedBlock && <Box  >
                    {activeBlock?.rooms.map(r => {
                        const atCapacity = r.capacity != null && r.beds.length >= r.capacity
                        return <Box style={{ marginTop: '1rem' }} key={r.id} >
                            <Flex between center gap='0.5rem' >
                                <TitleText>{r.name} <BodyText grey >({r.beds.length}/{r.capacity ?? 0})</BodyText></TitleText>
                            </Flex>
                            {r.beds.map(bed => <Flex gap='1rem' mt='16' key={bed.id} center>
                                <Input onChange={e => handleInput(e, r.id, bed.id)} value={bed.name} placeholder='Bed 1...' labelText='Name' nomarg invalid={tried && !bed.name} />
                                <HonestSelectInput name='state' defaultValue={bed.state?.value} onChange={(v: ISelectValue) => handleSelect(v, r.id, bed.id)} options={bedStatesOptions} labelText='State' nomarg invalid={tried && !bed.state} />
                                <RemoveItemBtn type='button' onClick={() => removeBed(r.id, bed.id)} aria-label='Remove bed'>
                                    <CloseIcon color='#FF4F46' />
                                </RemoveItemBtn>
                            </Flex>)}

                            <Button orange onClick={() => initiateBed(r.id)} disabled={atCapacity} style={{ marginTop: '3rem', opacity: atCapacity ? 0.5 : 1, cursor: atCapacity ? 'not-allowed' : 'pointer' }} > {atCapacity ? 'Capacity reached' : 'Add Bed'}</Button>
                            {tried && r.beds.length > (r.capacity ?? 0) && <BodyText style={{ color: '#FF4F46', marginTop: '0.5rem' }} >Beds count cannot exceed capacity ({r.capacity ?? 0})</BodyText>}
                        </Box>
                    })}
                </Box>}
            </Flex>
        </Box>
    </>
}
const FifthStep = ({ camp }) => {

    const counts = (() => {
        const blocks = camp?.blocks?.length ?? 0
        let rooms = 0
        let beds = 0
        camp?.blocks?.forEach(b => {
            rooms += b.rooms?.length ?? 0
            b.rooms?.forEach(r => { beds += r.beds?.length ?? 0 })
        })
        return { blocks, rooms, beds }
    })()

    const CountCard = ({ name, count }) => {

        const getIcon = () => {
            switch (name) {
                case 'Blocks':
                    return <OrangeBlockIcon />
                case 'Rooms':
                    return <OrangeRoomIcon />
                default:
                    return <OrangeBedIcon />
            }
        }

        return <Box style={{ flex: 1 }} >
            <Flex column gap='1rem'>
                <TitleText weight='bold' > {name}</TitleText>
                <Flex width='100%' between >
                    <ColoredSquare color={colors.paleOrange} width='36px' >{getIcon()}</ColoredSquare>
                    <TitleText size={28} >{count}</TitleText>
                </Flex>
            </Flex>
        </Box>
    }


    return <>
        <Flex column gap='1rem' >
            <TitleText weight='bold' size={24} >Review and Create</TitleText>
            <TitleText grey >Review your accommodation structure before creating</TitleText>
        </Flex>
        <Box width='100%' style={{ flex: 1, overflow: 'auto' }}  >
            <Flex width='100%' gap='1rem' >
                <CountCard name='Blocks' count={counts.blocks} />
                <CountCard name='Rooms' count={counts.rooms} />
                <CountCard name='Beds' count={counts.beds} />
            </Flex>
            <Box style={{ marginTop: '1rem' }} >
                <Flex column >
                    <Flex mb='16' center gap='0.5rem' >
                        <OrangeHouseIcon />
                        <TitleText>{camp.name}</TitleText>
                    </Flex>
                    <BodyText grey >{camp.address}</BodyText>
                    <BodyText style={{ marginTop: 8 }} grey >Address: {camp.address}</BodyText>
                    <Flex column gap='0.5rem' mt='16' >
                        {camp.blocks.map(b => <AccomodationBlockReveiw key={b.id} >
                            <OrangeBlockIcon />
                            <Flex column gap='0.5rem' >
                                <TitleText>{b.name}</TitleText>
                                {b.rooms.map(r => <Flex key={r.id} gap='0.5rem' style={{ borderLeft: '1px solid #8A8A8A', paddingLeft: '0.5rem' }} >
                                    <SmallOrangeBedIcon />
                                    <BodyText grey >{r.name} · {r.beds.length} beds</BodyText>
                                </Flex>)}
                            </Flex>
                        </AccomodationBlockReveiw>)}
                    </Flex>
                </Flex>
            </Box>
        </Box>
    </>
}

const validateStep = (step: number, camp: IAccommodationModalCamp): string | null => {
    if (!camp) return 'Please create the camp first'
    switch (step) {
        case 1:
            if (!camp.name) return 'Camp name is required'
            if (!camp.address) return 'Camp address is required'
            if (!camp.status) return 'Camp status is required'
            return null
        case 2:
            if (!camp.blocks?.length) return 'Add at least one block'
            for (const b of camp.blocks) {
                if (!b.name) return 'Block name is required'
                if (!b.status) return `Status is required for "${b.name}"`
                if (!b.genderPolicy) return `Gender policy is required for "${b.name}"`
                if (!b.tierPolicy) return `Tier policy is required for "${b.name}"`
            }
            return null
        case 3:
            for (const b of camp.blocks) {
                if (!b.rooms?.length) return `Add at least one room to "${b.name}"`
                for (const r of b.rooms) {
                    if (!r.name) return `Room name is required in "${b.name}"`
                    if (!r.capacity || r.capacity <= 0) return `Capacity is required for "${r.name}"`
                    if (!r.status) return `Status is required for "${r.name}"`
                }
            }
            return null
        case 4:
            for (const b of camp.blocks) {
                for (const r of b.rooms) {
                    if (r.beds.length > r.capacity) return `"${r.name}" cannot have more than ${r.capacity} bed(s)`
                    for (const bed of r.beds) {
                        if (!bed.name) return `Bed name is required in "${r.name}"`
                        if (!bed.state) return `State is required for "${bed.name}" in "${r.name}"`
                    }
                }
            }
            return null
        default:
            return null
    }
}

export const AddAccommodationModal = ({ closeModal }) => {
    const [active, setActive] = useState(1)
    const [camp, setCamp] = useState<IAccommodationModalCamp>(null)
    const [completed, setCompleted] = useState(false)
    const [triedSteps, setTriedSteps] = useState<Record<number, boolean>>({})
    const dispatch = useDispatch<AppDispatch>()

    const Step = ({ number, name }) => {
        return <Flex gap='0.5rem' center >
            <AccommodationStep active={active == number} >{number}</AccommodationStep>
            <BodyText weight='bold' grey={active !== number} style={active !== number ? { color: '#101010' } : {}}  >{name}</BodyText>

        </Flex>
    }
    const getSteps = () => {
        const tried = !!triedSteps[active]
        switch (active) {
            case 1:
                return <FirstStep camp={camp} setCamp={setCamp} tried={tried} />
            case 2:
                return <SecondStep camp={camp} setCamp={setCamp} tried={tried} />
            case 3:
                return <ThirdStep camp={camp} setCamp={setCamp} tried={tried} />
            case 4:
                return <FourthStep camp={camp} setCamp={setCamp} tried={tried} />
            case 5:
                return <FifthStep camp={camp} />
        }

    }

    const handleNextStep = () => {
        const error = validateStep(active, camp)
        if (error) {
            setTriedSteps(prev => ({ ...prev, [active]: true }))
            toast.error(error)
            return
        }
        if (active == 5) {
            handleSave()
        } else {
            setActive(prev => prev + 1)
        }

    }

    const handlePreviousStep = () => {
        if (active < 2) {
            closeModal()
        } else {
            setActive(prev => prev - 1)
        }

    }



    const Completed = () => {
        return <Box width='530px' >
            <Flex column gap='2rem' center >
                <TitleText size={24} weight='bold' >Accommodation Setup Completed</TitleText>
                <IconContainer color='#1E1E1E' ><PartyIcon /></IconContainer>
                <TitleText>Your accommodation structure has been successfully created. All camps, blocks, rooms, and beds are now ready for assignment.</TitleText>
                <Button orange width100 onClick={closeModal}>Close</Button>
            </Flex>
        </Box>
    }

    const handleSave = async () => {
        const resp = await dispatch(createCamp(camp))
        if (resp.meta.requestStatus === 'fulfilled') {
            setCompleted(true)
        }
    }



    return <AddAccommodationModalWrapper>
        {completed ? <Completed /> : <AddAccommodationModalContainer>
            <AddAccommodationSteps>
                <TitleText weight='bold' size={24} >Create New Accommodation</TitleText>
                <TitleText style={{ marginTop: '1rem' }} >Provide basic information about the accommodation camp</TitleText>
                <Flex mt='32' column gap='2rem' >
                    <Step number={1} name='Create Camp' />
                    <Step number={2} name='Add Blocks to Camp' />
                    <Step number={3} name='Add Rooms to Blocks' />
                    <Step number={4} name='Add Beds to Rooms' />
                    <Step number={5} name='Review & Create' />
                </Flex>
            </AddAccommodationSteps>
            <AddAccommodationModalContnet>
                <ModalCloseBtn type='button' onClick={closeModal} aria-label='Close'>
                    <CloseIcon />
                </ModalCloseBtn>
                {getSteps()}
                <Flex width='100%' end='true' gap='1rem' >
                    <Button onClick={handlePreviousStep} > {active < 2 ? 'Close' : 'Previous Step'} </Button>
                    <Button orange onClick={handleNextStep} >{active < 5 ? 'Next Step' : 'Create Accommodation'}</Button>
                </Flex>
            </AddAccommodationModalContnet>
        </AddAccommodationModalContainer>}
    </AddAccommodationModalWrapper>
}
export const bedStatesOptions = [{ label: 'Available', value: 1 }, { label: 'Occupied', value: 2 }, { label: 'Dirty', value: 3 }, { label: 'Blocked', value: 4 }]
